

const initializeFilters = (init: {} = {}) => {
    if (typeof window !== "undefined") {
        if (location.search) {
            const filters = new URLSearchParams(location.search)
            return filters ? JSON.parse(filters.get("filters")) : {}
        }
        else return init
    }
}

export default initializeFilters